module.exports = __webpack_public_path__ + "media/metronic/_theme/media/demos/preview/demo10-952ba6f14de78bd4c8d66665ee30c4a4.jpg";